import React from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import axios from 'axios';

// Import Babel Polyfill to provide es6 features to IE11
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import App from './App';

axios.defaults.withCredentials = true;

const root = document.getElementById('root');

const GlobalStyle = createGlobalStyle`
  ${reset}
  /* Full screen web app */
  html, body, #root {
    height: 100%;
  }

  /* Border Box reset */
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }

  /* Font Styles */
  body {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

function renderToDom() {
  if (root) {
    ReactDOM.render(
      <>
        <GlobalStyle />
        <App />
      </>,
      root,
    );
  }
}

renderToDom();

export default renderToDom;
